import { render } from "./TopDestinations.vue?vue&type=template&id=38a3d72f&scoped=true"
import script from "./TopDestinations.vue?vue&type=script&lang=js"
export * from "./TopDestinations.vue?vue&type=script&lang=js"

import "./TopDestinations.vue?vue&type=style&index=0&id=38a3d72f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a3d72f"]])

export default __exports__